import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BetOn, MarketType } from '@/types/betPlace';

export interface BetDetails {
  eventId?: number;
  position?: number;
  betOn?: BetOn;
  rate?: number;
  stake?: number;
  fancyPercentage?: number;
  runnerName?: string;
  selectionId?: string;
  marketId?: string;
  marketName?: string;
  marketCategory?: string;
  marketType: MarketType;
}

export interface BetLimit {
  min?: number | string | null;
  max?: number | string | null;
}

interface BetState extends BetLimit {
  betDetails: BetDetails | null;
  gameType: string | null;
}

const initialState: BetState = {
  betDetails: null,
  min: null,
  max: null,
  gameType: null,
};

export const betSlice = createSlice({
  name: 'bet',
  initialState,
  reducers: {
    setBetDetails: (state, action: PayloadAction<BetDetails>) => {
      state.betDetails = action.payload;
      state.gameType = null;
    },
    setBetStake: (state, action: PayloadAction<number>) => {
      if (state.betDetails) state.betDetails.stake = action.payload;
    },
    setBetRate: (state, action: PayloadAction<number>) => {
      if (state.betDetails) state.betDetails.rate = action.payload;
    },
    setGameType: (state, action: PayloadAction<string | null>) => {
      state.gameType = action.payload;
    },
    setBetLimits: (state, action: PayloadAction<BetLimit>) => {
      if (state.betDetails) {
        state.min = action.payload.min;
        state.max = action.payload.max;
      }
    },
    resetBetDetails: (state) => {
      state.betDetails = null;
      state.gameType = null;
    },
  },
});

export const { setBetDetails, setBetStake, setBetRate, setGameType, setBetLimits, resetBetDetails } =
  betSlice.actions;
export default betSlice.reducer;
